import { render, staticRenderFns } from "./MarketPosFiles.vue?vue&type=template&id=15196f99&scoped=true&"
import script from "./MarketPosFiles.vue?vue&type=script&lang=js&"
export * from "./MarketPosFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15196f99",
  null
  
)

export default component.exports